import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterOptions',
})
export class FilterOptionsPipe implements PipeTransform {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public transform(options: any[], labelKeys: string[], value: any, seperator: string = ''): any {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return options?.filter((option: any) => this.findFn(option, labelKeys, value, seperator));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private findFn(option: any, labelKeys: string[], value: any, seperator: string): boolean {
        if (value) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const res: string = labelKeys.map((field: string) => option[ field ]).filter((val: any) => !!val || val === 0).join(seperator);
            return res?.toString()?.toLocaleLowerCase().indexOf(value?.toString()?.toLocaleLowerCase()) > -1;
        } else {
            return true;
        }
    }

}
